import {Color} from "./interface/Color"

export const ShareUser: React.FC<Color> = ({
    color
  }) => {
    return(
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g id="Grupo_1508" data-name="Grupo 1508" transform="translate(-644 184)">
        <g id="Retângulo_533" data-name="Retângulo 533" transform="translate(644 -184)" fill={color} stroke="#707070" strokeWidth="1" opacity="0">
          <rect width="24" height="24" stroke="none"/>
          <rect x="0.5" y="0.5" width="23" height="23" fill="none"/>
        </g>
        <path id="União_1" data-name="União 1" d="M13.756,22.244A5.779,5.779,0,0,1,12,18a6.6,6.6,0,0,1,.049-.808L5.791,14.406A3.613,3.613,0,0,1,3.75,15,3.614,3.614,0,0,1,1.1,13.9,3.615,3.615,0,0,1,0,11.25,3.612,3.612,0,0,1,1.1,8.6,3.612,3.612,0,0,1,3.75,7.5,3.611,3.611,0,0,1,6.4,8.6q.057.057.111.115L16.53,4.252a4.122,4.122,0,0,1-.03-.5A3.612,3.612,0,0,1,17.6,1.1a3.757,3.757,0,0,1,5.306,0A3.614,3.614,0,0,1,24,3.75,3.614,3.614,0,0,1,22.9,6.4a3.757,3.757,0,0,1-5.306,0q-.057-.056-.11-.114L7.47,10.748a4.13,4.13,0,0,1,.03.5A3.763,3.763,0,0,1,7.262,12.6l5.5,2.447a6.174,6.174,0,0,1,1-1.29A5.779,5.779,0,0,1,18,12a5.992,5.992,0,0,1,6,6,5.992,5.992,0,0,1-6,6A5.779,5.779,0,0,1,13.756,22.244Zm3.644-4,2.58,2.58.84-.84L18.6,17.76V14.4H17.4Z" transform="translate(644 -184)" fill={color}/>
      </g>
    </svg>
    

    )
  }